import OnboardingDemo from './components/OnboardingDemo';
import './assets/OnboardingDemo.css';
import connect from './connect'

export default connect(OnboardingDemo);




// WEBPACK FOOTER //
// ./src/routes/OnboardingDemo/index.js